const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/bots/history.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { botsHistorySearchSchema } from "@/react/pages/CircleAi/Bots/BotsHistoryPage/botsHistorySearchSchema";
export const Route = createFileRoute("/_protected/ai/bots/history")({
  validateSearch: botsHistorySearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});